import { render } from "./TicketClaimView.vue?vue&type=template&id=0c5ef3c8&scoped=true"
import script from "./TicketClaimView.vue?vue&type=script&lang=js"
export * from "./TicketClaimView.vue?vue&type=script&lang=js"

import "./TicketClaimView.vue?vue&type=style&index=0&id=0c5ef3c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5ef3c8"]])

export default __exports__